import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'
import yn from 'yn'

const AccessibilityMessage = ({ isMessageClosed, closeMessage }) => {
  return (
    <div className={`accessibility-temporary-issue bg-featured color-brand-4 ${yn(isMessageClosed) && 'd-none'} w-100 zindex-high`}>
      <div className={`${window.innerWidth <= 420 ? 'container-fluid' : 'container'}`}>
        <div className='row'>
          <div className='d-flex align-items-center justify-content-start py-1 py-md-0' aria-hidden='true'>
            <Icon iconName='icon_warning color-brand-4 txt-body-lg' aria-hidden='true' />
          </div>
          <div className='col-9 col-md-10 d-flex align-items-center py-1 py-md-0'>
            <div className='accessibility-text-area'>
              <p className='txt-body-sm'>
                Estamos em evolução para tornar a experiência do site iupp mais acessível para todos. Por isso, por enquanto você poderá encontrar alguma dificuldade na navegação.
              </p>
            </div>
          </div>
          <div className='col d-flex align-items-center justify-content-end py-1 py-md-0'>
            <a href='javascript:void(0)' onClick={closeMessage} aria-label='Fechar mensagem' role='button' className='close-accessibility-message color-brand-4' tabIndex={0}>
              <Icon iconName='icon_close color-brand-4 txt-body-sm' />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

AccessibilityMessage.propTypes = {
  isMessageClosed: PropTypes.bool,
  closeMessage: PropTypes.func
}

export default AccessibilityMessage



// WEBPACK FOOTER //
// ./src/App/Header/AccessibilityMessage.js